import { render, staticRenderFns } from "./CustomUIDialog.vue?vue&type=template&id=5d125e7c&scoped=true&"
import script from "./CustomUIDialog.vue?vue&type=script&lang=js&"
export * from "./CustomUIDialog.vue?vue&type=script&lang=js&"
import style0 from "./CustomUIDialog.vue?vue&type=style&index=0&id=5d125e7c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d125e7c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
installComponents(component, {VCard,VCardText,VDialog})
